import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Kbd } from '@reveni-io/reveni-ui'

import { searchShortcutKeys } from '../constants'
import * as Styles from './styles'

const SearchTrigger = ({ onClick }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container onClick={onClick} data-testid="search-trigger">
      <MagnifyingGlassIcon size={16} color={theme.colors.border.default} />
      <Styles.Placeholder>{t('Buscar...')}</Styles.Placeholder>
      <Styles.Shortcut>
        {searchShortcutKeys.map((key, index) => (
          <Fragment key={key}>
            {index > 0 && '+'}
            <Kbd>{key}</Kbd>
          </Fragment>
        ))}
      </Styles.Shortcut>
    </Styles.Container>
  )
}

export default SearchTrigger
